import { z } from 'zod';
import { daySummarySchema, mealEntryViewSchema } from './log.js';
/* ==========================================================================
 *  POST /me/logs/parse — #ref delta logging (T30.1 / ADR-0032 "refDiff")
 *
 *  Logs one or more saved-meal references, each with an optional plain-
 *  language delta ("but quinoa instead of rice"). The referenced meal's
 *  components are hydrated deterministically (no AI call); the delta text,
 *  if any, gets a single small extraction pass. Response echoes a
 *  per-component diff so the client can render "Chicken bowl · modified"
 *  immediately, without waiting on the persisted feed.
 * ========================================================================== */
export const logParseRefSchema = z.object({
    savedMealId: z.string().uuid(),
    /** Plain-language modification, e.g. "but quinoa instead of rice". Empty
     *  string (the default) logs the saved meal unmodified — zero AI calls. */
    deltaText: z.string().max(500).default(''),
});
export const parseLogSchema = z.object({
    refs: z.array(logParseRefSchema).min(1),
    clientNow: z.string().datetime().optional(),
    timezone: z.string().max(64).optional(),
});
export const refDiffComponentActionSchema = z.enum(['unchanged', 'added', 'removed']);
/** One component's fate in the merge. `removed` components are not part of
 *  `entries` in the response (nothing was logged for them). */
export const refDiffComponentSchema = z.object({
    name: z.string(),
    action: refDiffComponentActionSchema,
});
export const parseLogResponseSchema = z.object({
    rawLogId: z.string().uuid(),
    entries: z.array(mealEntryViewSchema),
    diff: z.array(refDiffComponentSchema),
    day: daySummarySchema,
});
//# sourceMappingURL=log-parse.js.map